export default "__VITE_ASSET__b82715cc__"